/*
  * index.js
  * Router link to all component.
  * @author natirut duangpak 59161030
  * @create Date	2019-09-05
*/
import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app'
import 'firebase/auth'
import Admins from '../config/admin'
Vue.use(Router);
const routerOptions = [
  {
    path: '/login',
    component: 'v_login',
    meta:{title: 'เข้าสู่ระบบ'}
  },
  {
    path: '/main',
    component: 'v_main',
    meta:{
      requiresAuth:true,
      title: 'หน้าหลัก'
    }
  },
  {
    path: '/',
    component: 'v_login',
    meta:{
      // requiresAuth:true,
      title: 'หน้าแรก'
    }
  },
  {
    path: '/agent/:id',
    component: 'v_agent',
    meta:{
      requiresAuth:true,
      title: 'จัดการข้อมูลตัวแทน'
    }
  },
  // {
  //   path: '/register',
  //   component: 'v_register',
  //   meta:{
  //     requiresAuth:true,
  //     title: 'กรอกแบบฟอร์มสมัครสมาชิก'
  //   }
  // },
  {
    path: '/print-tm/:id',
    component: 'v_printTm',
    meta:{
      title: 'พิมพ์ใบสมัคร'
    },
  },
  {
    path: '/print-srikrung/:id',
    component: 'v_printSri',
    meta:{
      title: 'พิมพ์ใบสมัคร'
    }
  }
]

/*
	* routerOptions
	* import component.
	* @author natirut duangpak 59161030
	* @create Date	2019-09-05
*/
const routes = routerOptions.map(route => {
  return {
    path: route.path,
    component: () => import (`@/components/${route.component}.vue`),
    meta: route.meta
  }
})

/*
	* Router
	* redirect path root
	* @author natirut duangpak 59161030
	* @create Date	2019-09-05
*/
const router = new Router({
  mode: 'history',
  routes: [
    ...routes, {
      path: '*',
      redirect: '/'
    }
  ]
})

/*
	* beforeEach
	* check requiresAuth if null go to login
	* @author natirut duangpak 59161030
	* @create Date	2019-09-05
*/
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  const requiresAuth = to
    .matched
    .some(record => record.meta.requiresAuth)
  const user = firebase
    .auth()
    .currentUser
  if (requiresAuth && (!user || Admins.indexOf(user.email) < 0)) {
    next('/login')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js